import { render } from "./MultipleChoiceQuestionWithNoChoice.vue?vue&type=template&id=5cc1deb4&ts=true"
import script from "./MultipleChoiceQuestionWithNoChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoiceQuestionWithNoChoice.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__